export enum BulkScheduleGroupedByField {
  Aircraft = 'Aircraft',
  ClientContract = 'ClientContract',
}
